import { Image } from 'antd';

import iconContent from '../assets/img/ingresado.png'
const IngresadoIcon = props => <Image src={iconContent} height={36} {...props} />;
export default IngresadoIcon;
